var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Grid, TextField, Stack, Card, CardHeader, CardContent, FormControlLabel, Checkbox } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
var CaseTypeFileCategoriesEditor = /** @class */ (function (_super) {
    __extends(CaseTypeFileCategoriesEditor, _super);
    function CaseTypeFileCategoriesEditor(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        var caseType = (_a = _this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
        _this.state = {
            isValid: true,
            categories: caseType === null || caseType === void 0 ? void 0 : caseType.categories
        };
        return _this;
    }
    Object.defineProperty(CaseTypeFileCategoriesEditor.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            var marginStyle = {
                marginRight: '10px'
            };
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (!(caseType === null || caseType === void 0 ? void 0 : caseType.categories.length)) {
                return (_jsxs(Card, __assign({ className: "case-types-tab-panel" }, { children: [_jsx(CardHeader, { title: _jsxs(Grid, __assign({ container: true, alignItems: "center" }, { children: [_jsx(Grid, __assign({ item: true, xs: 4 }, { children: _jsx("h3", { children: "Categories" }, void 0) }), void 0), _jsx(Grid, __assign({ container: true, item: true, xs: 8, justifyContent: "flex-end" }, { children: _jsxs(Button, __assign({ variant: "outlined", onClick: function (e) { return _this.onAddClick(); } }, { children: [_jsx(AddCircleIcon, {}, void 0), _jsx("span", { children: "Add New" }, void 0)] }), void 0) }), void 0)] }), void 0) }, void 0), _jsx(CardContent, { children: _jsx(Stack, __assign({ flex: "1", alignItems: "center" }, { children: "No items" }), void 0) }, void 0)] }), void 0));
            }
            return (_jsxs(Card, { children: [_jsx(CardHeader, { title: _jsxs(Grid, __assign({ container: true, alignItems: "center" }, { children: [_jsx(Grid, __assign({ item: true, xs: 4 }, { children: _jsx("h3", { children: "Categories" }, void 0) }), void 0), _jsx(Grid, __assign({ container: true, item: true, xs: 8, justifyContent: "flex-end" }, { children: _jsxs(Button, __assign({ variant: "outlined", onClick: function (e) { return _this.onAddClick(); } }, { children: [_jsx(AddCircleIcon, {}, void 0), _jsx("span", { children: "Add New" }, void 0)] }), void 0) }), void 0)] }), void 0) }, void 0), _jsx(CardContent, __assign({ className: "overflow-auto" }, { children: caseType === null || caseType === void 0 ? void 0 : caseType.categories.map(function (category, index) { return (_jsxs(Grid, __assign({ container: true, style: { marginBottom: '20px' }, alignItems: "center" }, { children: [_jsx(Grid, __assign({ item: true, xs: 1, style: marginStyle }, { children: _jsx(FormControlLabel, { label: "Is Active", sx: { whiteSpace: 'nowrap' }, control: _jsx(Checkbox, { color: "primary", checked: category.isActive, onChange: function (e) { return _this.onIsActiveChange(e, index); } }, void 0) }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: marginStyle }, { children: _jsx(TextField, { disabled: !category.isActive, variant: "outlined", InputLabelProps: { shrink: true }, fullWidth: true, value: category.order, onChange: function (e) { return _this.onOrderChange(e, index); }, label: "Order" }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: marginStyle }, { children: _jsx(TextField, { disabled: !category.isActive, variant: "outlined", InputLabelProps: { shrink: true }, fullWidth: true, required: true, value: category.name, onChange: function (e) { return _this.onNameChange(e, index); }, label: "Name" }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: marginStyle }, { children: _jsx(TextField, { disabled: !category.isActive, variant: "outlined", InputLabelProps: { shrink: true }, fullWidth: true, value: category.description, onChange: function (e) { return _this.onDescriptionChange(e, index); }, label: "Description" }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: marginStyle }, { children: _jsx(TextField, { disabled: !category.isActive, variant: "outlined", InputLabelProps: { shrink: true }, fullWidth: true, value: category.externalID, onChange: function (e) { return _this.onExternalIdChange(e, index); }, label: "External ID" }, void 0) }), void 0), _jsx(Grid, __assign({ item: true, xs: 2, style: marginStyle }, { children: _this.renderDeleteButton(category, index) }), void 0)] }), index)); }) }), void 0)] }, void 0));
        }
    });
    Object.defineProperty(CaseTypeFileCategoriesEditor.prototype, "renderDeleteButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (category, index) {
            var _this = this;
            return (_jsxs(Button, __assign({ variant: "outlined", style: { marginLeft: '10px' }, onClick: function (e) { return _this.onRemoveClick(index); } }, { children: [_jsx(DeleteIcon, {}, void 0), _jsx("span", { children: "Delete" }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(CaseTypeFileCategoriesEditor.prototype, "onRemoveClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (index) {
            if (this.state.categories !== undefined && this.state.categories.length > 0) {
                var categories = this.state.categories;
                categories.splice(index, 1);
                this.onUpdateState(categories);
            }
        }
    });
    Object.defineProperty(CaseTypeFileCategoriesEditor.prototype, "onAddClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b, _c, _d;
            var categories = (_a = this.state.categories) !== null && _a !== void 0 ? _a : [];
            categories.push({
                id: '',
                isActive: true,
                caseTypeId: (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.currentCaseTypeId,
                organizationId: (_d = (_c = this.props.caseTypesStore) === null || _c === void 0 ? void 0 : _c.currentCaseType) === null || _d === void 0 ? void 0 : _d.organizationID,
                order: 999,
                name: '',
                description: '',
                externalID: '',
                isDeleted: false
            });
            this.onUpdateState(categories);
        }
    });
    Object.defineProperty(CaseTypeFileCategoriesEditor.prototype, "onOrderChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, index) {
            var _a;
            var categories = (_a = this.state.categories) !== null && _a !== void 0 ? _a : [];
            if (categories.length === 0)
                return;
            categories[index].order = Number(e.target.value);
            this.onUpdateState(categories);
        }
    });
    Object.defineProperty(CaseTypeFileCategoriesEditor.prototype, "onNameChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, index) {
            var _a;
            var categories = (_a = this.state.categories) !== null && _a !== void 0 ? _a : [];
            if (categories.length === 0)
                return;
            categories[index].name = e.target.value;
            this.onUpdateState(categories);
        }
    });
    Object.defineProperty(CaseTypeFileCategoriesEditor.prototype, "onDescriptionChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, index) {
            var _a;
            var categories = (_a = this.state.categories) !== null && _a !== void 0 ? _a : [];
            if (categories.length === 0)
                return;
            categories[index].description = e.target.value;
            this.onUpdateState(categories);
        }
    });
    Object.defineProperty(CaseTypeFileCategoriesEditor.prototype, "onExternalIdChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, index) {
            var _a;
            var categories = (_a = this.state.categories) !== null && _a !== void 0 ? _a : [];
            if (categories.length === 0)
                return;
            categories[index].externalID = e.target.value;
            this.onUpdateState(categories);
        }
    });
    Object.defineProperty(CaseTypeFileCategoriesEditor.prototype, "onIsActiveChange", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e, index) {
            var _a;
            var categories = (_a = this.state.categories) !== null && _a !== void 0 ? _a : [];
            if (categories.length === 0)
                return;
            categories[index].isActive = e.target.checked;
            this.onUpdateState(categories);
        }
    });
    Object.defineProperty(CaseTypeFileCategoriesEditor.prototype, "onUpdateState", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (categories) {
            var _a, _b;
            this.setState(__assign(__assign({}, this.state), { categories: categories }));
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.updateCategoriesCaseType(categories, (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.currentCaseTypeId);
        }
    });
    CaseTypeFileCategoriesEditor = __decorate([
        inject('caseTypesStore'),
        observer
    ], CaseTypeFileCategoriesEditor);
    return CaseTypeFileCategoriesEditor;
}(React.Component));
export default CaseTypeFileCategoriesEditor;
